import React, { Component } from 'react';
import StampSvg             from './App/StampSvg';
import './../css/Footer.css';

class AppStamp extends Component
{

    render = () => {
        return (
            <div className="stamp">
                <a target="_blank" rel="noopener noreferrer" href={ this.props.link } title={ this.props.title }>
                    <StampSvg color={ this.props.color } />
                </a>
            </div>
        );
    }

}

export default AppStamp;


// WEBPACK FOOTER //
// ./src/components/AppStamp.js